import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ClubListLayer from "../../components/Club/ClubListLayer";

const ClubList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Club Management"  />

        <ClubListLayer />
      </MasterLayout>
    </>
  );
};

export default ClubList;
